export class Stack {
    constructor({ length = 10, fill = null }) {
        this.length = length;
        this.fill = fill;
        this.array = new Array(length).fill(fill);
    }
    push(value) {
        const [_, ...rest] = this.array;
        this.array = [...rest, value];
    }
}
